import { render } from "./DocumentGeneration.vue?vue&type=template&id=550476de&ts=true"
import script from "./DocumentGeneration.vue?vue&type=script&lang=ts"
export * from "./DocumentGeneration.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__